export function hasPickedCMSMarketAndNotResolvedYetMarket(event) {
    return Boolean(!event.market && event.IsOutright || event.IsQA);
}
//# sourceMappingURL=hasPickedCMSMarketAndNotResolvedYetMarket.js.map